import styled from "styled-components";
import * as RD from "../../../components";
import { TimeSlot } from "../../../types/TimeSlot";
import DateHelper from "../../../helpers/DateHelper";
import { TimeSlotButtonStyles } from "../../../types/styles";
import { ChevronRightSolid } from "../../../assets/icons";
import { useTranslation } from "react-i18next";

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 24px;
  min-height: 150px;
`;

const TimeSlotContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const CheckOtherVenuesButton = styled.button<{
  styles: { OverallGeneralTextColour: string };
}>`
  display: flex;
  justify-content: space-between;
  color: ${({ styles }) => styles.OverallGeneralTextColour};
  font-weight: 700;
  font-size: 15px;
  font-family: inherit;
  background: none;
  border: none;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  padding: 0;
`;

const IconContainer = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export type AvailabilityWithinTwoHoursProps = {
  timeSlots: TimeSlot[];
  selectedTimeSlot: TimeSlot | null;
  setSelectedTimeSlot: React.Dispatch<React.SetStateAction<TimeSlot | null>>;
  checkOtherVenues: () => void;
  styles: TimeSlotButtonStyles & { OverallGeneralTextColour: string };
};

export const AvailabilityWithinTwoHours: React.FC<
  AvailabilityWithinTwoHoursProps
> = ({
  timeSlots,
  selectedTimeSlot,
  setSelectedTimeSlot,
  checkOtherVenues,
  styles,
}) => {
  const { t } = useTranslation();
  const selectTimeSlot = (timeSlot: TimeSlot) => {
    if (
      selectedTimeSlot?.MicrositeName === timeSlot.MicrositeName &&
      selectedTimeSlot?.TimeSlot.TimeSlot === timeSlot.TimeSlot.TimeSlot
    ) {
      setSelectedTimeSlot(null);
    } else {
      setSelectedTimeSlot(timeSlot);
    }
  };

  return (
    <StyledContainer data-id="availability-within-two-hours">
      <TimeSlotContainer data-id="time-slot-container">
        {timeSlots.map((timeSlot) => (
          <RD.TimeSlotButton
            text={DateHelper.sliceTimeSlot(timeSlot) || ""}
            onClick={() => selectTimeSlot(timeSlot)}
            isSelected={
              timeSlot.TimeSlot.TimeSlot ===
                selectedTimeSlot?.TimeSlot.TimeSlot &&
              timeSlot.MicrositeName === selectedTimeSlot?.MicrositeName
            }
            key={timeSlot.TimeSlot.TimeSlot}
            styles={styles}
          />
        ))}
      </TimeSlotContainer>
      <RD.Divider styles={styles} dataId="divider">
        {t("Or")}
      </RD.Divider>
      <CheckOtherVenuesButton
        onClick={checkOtherVenues}
        type="button"
        styles={styles}
        data-id="check-other-venues-button"
      >
        {t("CheckAvailabilityAtOurOtherVenues")}
        <IconContainer>
          <RD.Icon icon={ChevronRightSolid} />
        </IconContainer>
      </CheckOtherVenuesButton>
    </StyledContainer>
  );
};

export default AvailabilityWithinTwoHours;
